import Charts from "react-apexcharts";
import { Card, CardBody, Col, Row } from "reactstrap";
import CommonCardHeader from "../../../Common/CommonCardHeader";
import { MonthlyHistoryHeading } from "../../../Constant";
import { MARKET_MONTHLY_CHART } from "../../../Data/Widgets/ChartWidgets";

const MonthlyHistory = () => {
  return (
    <Col md="12" className="box-col-6">
      <Card className="o-hidden">
        <CommonCardHeader title={MonthlyHistoryHeading} className="border-bottom-1" />
        <div className="bar-chart-widget">
          <CardBody className="bottom-content">
            <Row>
              <Col xs="12">
                <Charts options={MARKET_MONTHLY_CHART} series={MARKET_MONTHLY_CHART.series} type="bar" height={360}/>
              </Col>
            </Row>
          </CardBody>
        </div>
      </Card>
    </Col>
  );
};

export default MonthlyHistory;
